import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';
import { isExistI18nTranslate } from '../../../../../../utils';
import { CdnIcon, SafeHtml } from '@shared/ui';
const Conditions = ({ className }) => {
    const { Conditions: css } = useTheme('Checkin');
    const { t } = useTranslation('CheckinConditions');
    return (React.createElement("div", { className: cn(css.container, className) },
        React.createElement("div", { className: css.title }, t('Check-in conditions')),
        React.createElement("div", { className: css.icon },
            React.createElement(CdnIcon, { icon: "Document/Boarding pass" })),
        React.createElement("ul", { className: css.conditions }, [...Array(10)].map((_, index) => {
            const key = `Rules_${index}`;
            const isExistTranslate = isExistI18nTranslate(key, { ns: 'CheckinConditions' });
            if (!isExistTranslate) {
                return null;
            }
            return React.createElement(SafeHtml, { key: index, tag: "li", html: t(key) });
        }))));
};
export default Conditions;
